<template>
  <div ref="container" class="banner-tap-container">
    <div class="banner-tap-content max-width">
      <div @click="$emit('click', item )" v-for="item in dataList" :key="item.id" class="tap-item">
        <div class="title">{{item.title}}</div>
        <div class="subTitle">{{item.subTitle}}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    dataList: {
      type: Array,
      default: () => []
    }
  },
  mounted() {
    window.addEventListener("scroll", this.sticky);
  },
  destroyed() {
    window.removeEventListener("scroll", this.sticky);
  },
  methods: {
    sticky() {
      // 组件吸顶
      const tap = this.$refs.container;
      const container = this.$refs.container.parentElement;
      const containerObj = container.getBoundingClientRect();
      const tapObj = tap.getBoundingClientRect();
      if (containerObj.y + containerObj.height - tapObj.height > 0) {
        tap.style.position = "absolute";
        tap.style.bottom = 0;
        tap.style.top = "unset";
        tap.style.backgroundColor = "rgba(1, 14, 41, 0.7)";
      } else {
        tap.style.position = "fixed";
        tap.style.bottom = "unset";
        tap.style.top = 0;
         tap.style.backgroundColor = "rgba(1, 14, 41, 1)";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import url("~@/assets/css/common.scss");
.banner-tap-container {
  width: 100%;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(1, 14, 41, 0.7);
  min-height: 40px;
  z-index: 10;
  .banner-tap-content {
    max-width: 1366px;
    margin: auto;
    display: flex;
    .tap-item {
      user-select: none;
      cursor: pointer;
      padding: 1.5vw 0;
      flex-grow: 1;
      color: #fff;

      &:hover {
        background-color: #fff;
        color: #333;
        > .title {
          color: #333;
        }
        > .subTitle {
          color: #333;
        }
      }
      .title {
        font-size: 1vw;
        font-family: SourceHanSansCN-Bold;
        font-weight: bold;
        color: #fff;
        line-height: 25px;
        width: 60%;
        margin: auto;
        margin-bottom: 0.6vw;
      }
      .subTitle {
        font-size: 0.7vw;
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.8);
        width: 60%;
        margin: auto;
      }
    }
  }
}
</style>
